import { useUpdateStytchNameMutation } from '@/queries/profile'
import { useStytchMember } from '@stytch/react/b2b'
import { useEffect, useState } from 'react'

export function useNameManagement() {
	const { member } = useStytchMember()
	const updateNameMutation = useUpdateStytchNameMutation()

	const [tempName, setTempName] = useState(() => member?.name || '')
	const [nameSuccess, setNameSuccess] = useState(false)
	const [nameError, setNameError] = useState<string | undefined>()

	// Sync temp name when member data changes
	useEffect(() => {
		if (member?.name) {
			setTempName(member.name)
		}
	}, [member?.name])

	const handleNameUpdate = async (newName: string) => {
		if (!member?.member_id || newName.trim() === member.name) {
			return
		}

		// Clear previous error
		setNameError(undefined)

		try {
			await updateNameMutation.mutateAsync({ name: newName })

			setNameSuccess(true)
			setTimeout(() => setNameSuccess(false), 2000)
		} catch (error) {
			// Set error state
			setNameError('Failed to update name')
			// Revert to original value on error
			setTempName(member.name || '')
		}
	}

	return {
		tempName,
		setTempName,
		nameSuccess,
		nameLoading: updateNameMutation.isPending,
		nameError,
		handleNameUpdate,
		memberName: member?.name || '',
	}
}
